<div
    class="edit-btn"
    *ngIf="
        (currentProfile.profile_id === profile.profile_id
            ? permissions.editOwnProfile
            : permissions.personalInfoEdit) &&
        currentProfile.role_id === ROLE_CODES.ORGANIZATION_ADMIN &&
        [ROLE_CODES.PROFESSIONAL, ROLE_CODES.ORGANIZATION_ADMIN].includes(profile.role_id) &&
        editProfileAllowed
    "
    (click)="editProfile(profile)"
>
    <span class="fa fa-pencil"></span>
</div>
<cm-profile-card-avatar
    [profile]="profile"
    [canUpdateAvatar]="isUpdateAvatarAllowed"
    [currentProfile]="currentProfile"
    (updateAvatar)="updateAvatar($event)"
></cm-profile-card-avatar>
<h2 class="user-name">{{ profile.first_name }} {{ profile.last_name }}</h2>
<div class="address">
    <div class="address__row" *ngIf="profile.address1 || profile.city">{{ profile.address1 }} {{ profile.city }}</div>
    <div class="address__row" *ngIf="profile.state_code || profile.zip || profile.country_code">
        {{ profile.state_code }} {{ profile.zip }} {{ profile.country_code }}
    </div>
</div>
<div class="login-as" *ngIf="showLoginAs">
    <button class="btn btn-default" (click)="loginAs.emit(profile)">Login As</button>
</div>
<div class="divider" *ngIf="profile.phone_number || profile.email"></div>
<div class="organization-name" *ngIf="profile.organization_name">{{ profile.organization_name }}</div>
<div>
    <table class="profile-info-table">
        <tr *ngIf="profile.phone_number">
            <td><span class="fa fa-phone"></span></td>
            <td>{{ profile.phone_number }}</td>
        </tr>
        <tr *ngIf="profile.email">
            <td><span class="fa fa-envelope"></span></td>
            <td>
                <div [ngbTooltip]="emailTooltip" tooltipClass="max-600" (click)="contentCopy($event)">
                    <input type="text" class="ellipsis-text copied-input" [ngModel]="profile.email" />
                </div>
            </td>
        </tr>
        <tr *ngIf="profile.mobilePhoneNumber">
            <td><span class="fa fa-mobile fa-font-22"></span></td>
            <td><span class="underline">Mobile phone</span>: {{ mobilePhoneNumber }}</td>
        </tr>
        <tr
            *ngIf="
                currentProfile.role_id === ROLE_CODES.ORGANIZATION_ADMIN && profile.role_id === ROLE_CODES.PROFESSIONAL
            "
        >
            <td><span class="fa fa-id-card"></span></td>
            <td>
                <div class="line-centered">
                    <span class="underline">ID</span>:<span
                        class="ellipsis-text"
                        [ngbTooltip]="profile.organization_profile_id"
                        >{{ profile.organization_profile_id }}</span
                    >
                    <button
                        *ngIf="permissions.internalIdEdit && editProfileAllowed"
                        class="btn btn-default"
                        (click)="onInternalIdUpdate()"
                    >
                        {{ profile.organization_profile_id ? 'Update' : 'Add' }}
                    </button>
                </div>
            </td>
        </tr>
        <tr *ngIf="profile.role_id === ROLE_CODES.PROFESSIONAL && profile.organizationRole?.organizationRoleName">
            <td><span class="fa fa-users"></span></td>
            <td>
                <div class="line-centered">
                    <span class="underline">Role</span>:<span
                        class="ellipsis-text"
                        [ngbTooltip]="profile.organizationRole.organizationRoleName"
                        >{{ profile.organizationRole.organizationRoleName }}</span
                    >
                </div>
            </td>
        </tr>
        <tr *ngIf="permissions.titlesFeatureFlag && profile.title_name">
            <td><span class="fa fa-id-card"></span></td>
            <td>{{ profile.title_name }}</td>
        </tr>
        <tr *ngIf="permissions.managersFeatureFlag && profile.managerData">
            <td><span class="fa fa-envelope"></span></td>
            <td>
                <div class="line-centered">
                    <span class="underline">Manager</span>:<span
                        class="ellipsis-text"
                        [ngbTooltip]="profile.managerData.email"
                        tooltipClass="max-600"
                        >{{ profile.managerData.firstName }} {{ profile.managerData.lastName }}</span
                    >
                </div>
            </td>
        </tr>
    </table>

    <cm-profile-location-info *ngIf="permissions.locationsFeatureFlag" [profile]="profile"></cm-profile-location-info>
</div>
<ng-template #emailTooltip>
    {{ profile.email }}
    <div class="mt-2">(Click to copy)</div>
</ng-template>
